import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  is_display_zone_register_component = false;
  zoneUpdate = new EventEmitter<ZONE>();

  downloadZone = new EventEmitter<boolean>();

  private _zone_data: ZONE = null;
  constructor() {
  }

  set set_zone_data(zone) {
    this._zone_data = zone;
  }

  get get_zone_data() {
    return this._zone_data;
  }
}

export interface ZONE {
  id: number;
  name: string;
}
